import { FormControl, FormLabel, Select } from '@chakra-ui/react'
import { useCategories } from '@src/hooks/api'

export interface CategoriesSelectProps {
  value?: number
  onChange: (value: number) => void
}

export const CategoriesSelect = (props: CategoriesSelectProps) => {
  const { data } = useCategories()

  return (
    <FormControl id="category" width="full" height="auto" minWidth="250px">
      <FormLabel fontSize="1.25rem" fontWeight="bold">
        Categoria
      </FormLabel>
      <Select
        name="category"
        value={props.value}
        onChange={e => props.onChange(+e.target.value)}
        width="full"
        height="3.25rem"
      >
        <option value={0}>-</option>
        {data?.map(item => (
          <option key={item.id} value={item.id}>
            {item.title}
          </option>
        ))}
      </Select>
    </FormControl>
  )
}
